// extracted by mini-css-extract-plugin
export default {"SignupPage":"Signup_SignupPage__LCcZw","SignupPage__row":"Signup_SignupPage__row__d2-xF"};